export default "__VITE_ASSET__dc0c620b__"